import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../api";
import { useI18n } from "../I18nContext";

export default function ForgotPassword() {
  const { t, lang, setLang } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tb-app tb-auth-page">
      <Link to="/" className="tb-app-logo">Traction<span>Board</span></Link>
      {sent ? (
        <div className="tb-form" data-testid="forgot-sent">
          <h1 className="tb-h1" style={{ marginBottom: "0.5rem", fontSize: "1.4rem" }}>
            {t("auth.checkEmailTitle")}
          </h1>
          <p className="tb-muted">{t("auth.checkEmailBody")}</p>
          <Link to="/login" className="tb-ghost-btn" style={{ textDecoration: "none", textAlign: "center" }}>
            {t("auth.backToLogin")}
          </Link>
        </div>
      ) : (
        <form className="tb-form" onSubmit={submit} data-testid="forgot-form">
          <h1 className="tb-h1" style={{ marginBottom: "0.5rem", fontSize: "1.4rem" }}>
            {t("auth.forgotTitle")}
          </h1>
          <p className="tb-muted" style={{ margin: 0 }}>{t("auth.forgotHelp")}</p>
          <div>
            <label>{t("auth.email")}</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" autoComplete="email" />
          </div>
          {err && <div className="tb-form-error">{err}</div>}
          <button type="submit" className="tb-primary-btn" disabled={loading} data-testid="forgot-submit">
            {loading ? t("auth.loading") : t("auth.sendResetLink")}
          </button>
          <div className="tb-lang-pick" style={{ justifySelf: "center" }}>
            <button type="button" className={lang === "en" ? "on" : ""} onClick={() => setLang("en")}>EN</button>
            <button type="button" className={lang === "fr" ? "on" : ""} onClick={() => setLang("fr")}>FR</button>
          </div>
        </form>
      )}
      <div className="tb-auth-switch">
        <Link to="/login">{t("auth.backToLogin")}</Link>
      </div>
    </div>
  );
}
